import { defineConfig } from "rasengan";

export default defineConfig({
  reactStrictMode: false,

  server: {
    production: {
      hosting: "vercel"
    }
  }
});
